import Area, { IArea } from "./Area";
import Application from "../Application";
import { IRouter } from "../runtime/Router";
import FormDetailsPage from "../ui/pages/form/FormDetailsPage";
import ShowFormDetailsInteractor from "../interactor/form/ShowFormDetailsInteractor";
import ShowFormsInteractor from "../interactor/form/ShowFormsInteractor";
import FormsPage from "../ui/pages/form/FormsPage";

export default class FormArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor(application: Application, router: IRouter) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes(
      {
        path: "/forms",
        page: this.createPage({
          Page: FormsPage,
          action: this.showFormsPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/previous-forms",
        page: this.createPage({
          Page: FormsPage,
          action: this.showPreviousFormsPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path:
          "/reporting-periods/:reportingPeriodApplicantId/forms/:formId/details",
        page: this.createPage({
          Page: FormDetailsPage,
          action: this.showFormDetailsReport.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path:
          "/reporting-periods/:reportingPeriodApplicantId/previous-forms/:formId/details",
        page: this.createPage({
          Page: FormDetailsPage,
          action: this.showPreviousFormDetailsReport.bind(this)
        }),
        options: {
          secure: true
        }
      }
    );
  }

  public showFormsPage() {
    return this.application.container
      .resolve<ShowFormsInteractor>("showForms")
      .execute();
  }

  public showPreviousFormsPage() {
    return this.application.container
      .resolve<ShowFormsInteractor>("showForms")
      .execute(true);
  }

  public showFormDetailsReport(params: any) {
    return this.application.container
      .resolve<ShowFormDetailsInteractor>("showFormDetailsReport")
      .execute(
        parseInt(params.reportingPeriodApplicantId, 10),
        parseInt(params.formId, 10),
        parseInt(params.version)
      );
  }

  public showPreviousFormDetailsReport(params: any) {
    return this.application.container
      .resolve<ShowFormDetailsInteractor>("showFormDetailsReport")
      .execute(
        parseInt(params.reportingPeriodApplicantId, 10),
        parseInt(params.formId, 10),
        parseInt(params.version),
        true
      );
  }
}
